<template>
  <div class="contents contents--full layout-wrapper">
    <div class="contents__wrap">
      <div class="sub-top">
        <h3>기관명: {{ orgName }}의 내부통제체계 진단 관리</h3>

        <div class="sub-top__navi">
          <span class="icon-home navi--home"></span>
          <span>품질등급 확인서</span>
        </div>
      </div>

      <!-- 발급번호 -->
      <div class="qgc-header">
        <div class="issue-number">발급번호 2024-AQ-1203</div>
      </div>

      <!-- 제목 -->
      <div class="qgc-title">내부감사 품질 등급 확인서</div>

      <!-- 청색 바 -->
      <div class="qgc-blue-bar">
        INTERNAL AUDIT QUALITY ASSESSMENT SERVICE &nbsp;&nbsp;&nbsp; INTERNAL AUDIT QUALITY ASSESSMENT SERVICE
      </div>

      <!-- 회사 정보 및 등급 -->
      <div class="content-wrapper">
        <!-- 회사 정보 테이블 -->
        <table class="grade-table">
          <tr>
              <th>회사명</th>
              <td>기술보증기금</td>
          </tr>
          <tr>
              <th>상임감사</th>
              <td>임명배</td>
          </tr>
          <tr>
              <th>사업자번호</th>
              <td>601-82-03112</td>
          </tr>
          <tr>
              <th>주소</th>
              <td>부산광역시 남구 문현금융로 33</td>
          </tr>
          <tr>
              <th>등급평가입</th>
              <td>2024.12.02</td>
          </tr>
          <tr>
              <th>등급유효기간</th>
              <td>2025.12.01</td>
          </tr>
        </table>

        <!-- 등급 박스 -->
        <div class="grade-box">
          <div class="grade-title">내부감사 품질 등급</div>
          <div class="grade-score">A+</div>
        </div>
      </div>

      <!-- 유의사항 -->
      <div class="notice">
        <div class="notice-title">⚠ 유의사항</div>
        <ol class="notice-list">
          <li>본 품질등급확인서는 '국제내부감사기준'에 따라 평가를 실시하여 작성하였습니다.</li>
          <li>상기 품질등급은 기관이 제출한 각종 자료 및 현장실사, 인터뷰 등을 기초로 평가한 것입니다.</li>
          <li>등급 유효기간 동안 국제내부감사기준의 각 분야 및 세부항목에 대한 기준이 유지될 수 있도록 노력하는 것이 필요합니다.</li>
          <li>품질등급은 평가일자로부터 유효일까지 유지되며, 이후 변경사항은 반영되지 않습니다.</li>
          <li>본 품질 등급을 홍보할 때, 어떤 방식이든 허위 사실을 기재해서는 안 됩니다.</li>
          <li>등급 관련 문의사항은 070-4489-7241로 연락 주시기 바랍니다.</li>
        </ol>
      </div>

      <!-- 기관명 및 도장 -->
      <div class="footer_QGC">한국전산감사협회</div>
      <div class="seal">
        <img src="/seal.png" alt="인증 도장">
      </div>

      <!-- PDF 뷰어 -->
      <pdf-embed :source="pdfUrl" class="pdf-viewer" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import PdfEmbed from "vue-pdf-embed";

const orgName = ref("기관명");
const pdfUrl = ref("/pdfTEST.pdf"); // public 폴더에 저장된 PDF

onMounted(() => {
  console.log("PDF 파일 로드:", pdfUrl.value);
});
</script>

<style>
/* PDF 뷰어 */
.pdf-viewer {
  width: 100%;
  height: 80vh; /* 화면의 80% 높이 */
}

/* 발급번호 스타일 */
.qgc-header {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  margin-top: 10px;
}

/* 제목 스타일 */
.qgc-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-top: 10px;
}

/* 청색 바 */
.qgc-blue-bar {
  background-color: #1F3A72;
  color: white;
  text-align: center;
  font-weight: bold;
  padding: 8px;
  margin-top: 10px;
}

/* 콘텐츠 정렬 */
.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}

/* 회사 정보 테이블 */
.grade-table {
  width: 60%;
  border-collapse: collapse;
  font-family: 'Arial', sans-serif;
}

.grade-table th, .grade-table td {
  border: 1px solid #1F3A72;
  padding: 12px;
  text-align: center;
  font-size: 18px;
}

.grade-table th {
  background-color: #D3D3D3;
  font-weight: bold;
  color: #1F3A72;
  width: 30%;
}

.grade-table td {
  width: 70%;
  font-weight: bold;
}

/* 등급 표시 박스 */
.grade-box {
  width: 30%;
  border: 2px solid #1F3A72;
  text-align: center;
  padding: 20px;
  font-weight: bold;
}

.grade-title {
  background-color: #1F3A72;
  color: white;
  padding: 10px;
  font-weight: bold;
}

.grade-score {
  font-size: 50px;
  color: #1F3A72;
  font-weight: bold;
  margin-top: 20px;
}

/* 유의사항 */
.notice {
  border: 1px solid #1F3A72;
  padding: 10px;
  margin-top: 20px;
}

.notice-title {
  background-color: #1F3A72;
  color: white;
  padding: 8px;
  font-weight: bold;
}

.notice-list {
  margin: 10px;
}

.notice-list li {
  font-size: 14px;
  margin: 5px 0;
}

/* 기관명 */
.footer_QGC {
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
}

/* 도장 */
.seal {
  text-align: center;
  margin-top: 10px;
}

.seal img {
  width: 80px;
}
</style>
